import React, { useEffect, useState } from 'react'
import {
    Datagrid,
    Edit,
    EditButton,
    Filter,
    List,
    SelectInput,
    SimpleForm,
    TextField as TextFieldRa,
    TextInput,
    useNotify
} from 'react-admin'
import api from '../../../Services/Api'
import removedIcon from '@material-ui/icons/Delete'
import searchIcon from '@material-ui/icons/Search'
import { Box, ButtonBase } from '@material-ui/core'
export const SearchIcon = searchIcon;
export const RemovedIcon = removedIcon;

export const SearchFilter = (props) => {

    const [insurerOptions, setInsurerOptions] = React.useState([])


    useEffect(() => {
        ; (async () => {
            try {
                const result = await api.get(`admin/insurers?_order=ASC&_sort=name`)
                let insurers = result?.data;
                setInsurerOptions(insurers)
            } catch (error) {
                console.log('Erro ao consultar insurers', error)
            }
        })()
    }, [])

    return (
        <Filter {...props}>
            <SelectInput label="Seguradora" source="insurerId" choices={insurerOptions} alwaysOn />
            <TextInput label="Nome" source="name" alwaysOn />
            <TextInput label="Ms Nome" source="relatedProductName" alwaysOn />
        </Filter>
    )
}

export const SearchList = (props) => {
    return (
        <List
            {...props}
            title="Relacionador de Seguros - Seguros Promo"
            exporter={false}
            bulkActionButtons={false}
            sort={{ field: 'id', order: 'DESC' }}
            filters={<SearchFilter />}
            perPage={50}
            actions={false}
        >
            <Datagrid>
                <TextFieldRa source="id" label="Id" sortable={false} />
                <TextFieldRa source="name" label="Nome" sortable={true} />
                <TextFieldRa source="relatedProductName" label="Produto MS Relacionado" sortable={true} />
                <TextFieldRa source="insurerId" label="Seguradora" sortable={false} />
                <EditButton label="" />
            </Datagrid>
        </List>
    )
}

export const SearchEdit = (props) => {
    const [relatedProductName, setRelatedProductName] = useState('');
    const notify = useNotify();

    const handleVerify = async () => {
        try {
            await api.get(`/admin/products/name/${relatedProductName}`);
            notify(`Produto verificado com sucesso`, { type: 'success' });
        } catch (err) {
            notify('Erro ao verificar produto, verifique se o nome do produto está correto', { type: 'error' });
        }
    };

    return (
        <Edit {...props}>
            <SimpleForm redirect="list">
                <TextInput label="Id" source="id" inputProps={{ readOnly: true }} />
                <TextInput label="Nome do produto" source="name" inputProps={{ readOnly: true }} />

                {/* Input + Botão em coluna */}
                <Box display="flex" flexDirection="column" gap={1}>
                    <TextInput
                        label="Produto MS Relacionado"
                        source="relatedProductName"
                        onChange={(e) => setRelatedProductName(e.target.value)}
                        fullWidth
                    />
                    <ButtonBase
                        onClick={handleVerify}
                        style={{
                            backgroundColor: '#1976d2',
                            color: '#ffffff',
                            border: '1px solid #115293',
                            borderRadius: '4px',
                            height: '48px', // altura aumentada
                            padding: '0 32px', // padding horizontal maior
                            fontSize: '16px', // texto um pouco maior
                            textTransform: 'none',
                            width: 'fit-content',
                        }}
                    >
                        Verificar
                    </ButtonBase>
                </Box>
            </SimpleForm>
        </Edit>
    );
};